export const TOGGLE_FILTER = 'BEAMLY/CCX/TOGGLE_FILTER';
export const SET_SELECTED_FILTERS = 'BEAMLY/CCX/SET_SELECTED_FILTERS';
export const TOGGLE_FILTER_CATEGORY = 'BEAMLY/CCX/TOGGLE_FILTER_CATEGORY';

export const toggleFilter = ({ categoryName, optionName }) => ({
  type: TOGGLE_FILTER,
  categoryName,
  optionName,
});

export const setSelectedFilters = ({ selectedFilters }) => ({
  type: SET_SELECTED_FILTERS,
  selectedFilters,
});

export const toggleFilterCategory = ({ categoryName }) => ({
  type: TOGGLE_FILTER_CATEGORY,
  categoryName,
});
